/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { RESTService, ReduxUtils } from '@spm/core';
import models from './models';

/**
 * Post request to path:
 * /v1/ua/verifications/create_caseworker_task
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postVerificationsCreateCaseworkerTaskUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/verifications/create_caseworker_task`;

  RESTService.post(url, data, (success, response) => {
    callback(success, response);
  });
};

/**
 * Post request to path:
 * /v1/ua/verifications/link_file
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postVerificationsLinkFileUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/verifications/link_file`;

  RESTService.post(url, data, (success, response) => {
    callback(success, response);
  });
};

/**
 * Deletes from api:
 * /v1/ua/verifications/{verificationId}/file_links/{linkId}
 *
 * @param {string} verificationId.
 * @param {string} linkId.
 * @param {any} callback function to call once this function has finished
 */
const deleteVerificationsFileLinksByLinkIdUtil = (verificationId, linkId, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/verifications/${verificationId}/file_links/${linkId}`;
  RESTService.del(url, (success, response) => {
    callback(success, response);
  });
};

/**
 * Gets SPMVerificationList from api:
 * /v1/ua/verifications
 *
 * @param {string} caseId.
 * @param {string} personId.
 * @param {any} callback function to call once this function has finished
 */
const fetchVerificationsUtil = (caseId, personId, callback) => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/ua/verifications?caseId=${caseId}&personId=${personId}`,
    models.SPMVerificationList
  );
};

/**
 * Gets SPMVerification from api:
 * /v1/ua/verifications/{verificationId}
 *
 * @param {string} verificationId.
 * @param {any} callback function to call once this function has finished
 */
const getVerificationsByVerificationIdUtil = (verificationId, callback) => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/ua/verifications/${verificationId}`,
    models.SPMVerification
  );
};

/**
 * Post request to path:
 * /v1/ua/verifications/sd_create_caseworker_task
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postVerificationsSdCreateCaseworkerTaskUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/verifications/sd_create_caseworker_task`;

  RESTService.post(url, data, (success, response) => {
    callback(success, response);
  });
};

export {
  postVerificationsCreateCaseworkerTaskUtil,
  postVerificationsLinkFileUtil,
  deleteVerificationsFileLinksByLinkIdUtil,
  fetchVerificationsUtil,
  getVerificationsByVerificationIdUtil,
  postVerificationsSdCreateCaseworkerTaskUtil,
};
